<template>
	<div class="weijuzheng list-wrapper" v-lazy-container="{ selector: 'img' }">
			<div class="item-list">
				<div class="item" v-for="item in list" :key="item.id">
					<a :href="item.url" target="_blank">
						<img :data-src="item.icon" :alt="item.title" class="logo">
						<div class="name">{{item.title}}</div>
					</a>
				</div>
			</div>
			<div>
				<loading v-show="loading">
					<span class="more-text">正在加载</span>
				</loading>
			</div>
	</div>
	
</template>
<script>
	import axios from 'axios'
	import Loading from '../components/Loading'

	export default {
		data(){
			return {
				loading: false,
				list: []
			}
		},
		props: ['type'],
		components: {
			Loading
		},
		created(){
			this.loading = true
			axios({
				url: '/cdfb/Index/Tag/tagList',
				method: 'POST',
				data: {
					type: this.type
				}
			}).then(rep => {
				const {code , data, msg} = rep.data
				if(code == 0){
					this.list = data.tagList
				} else{
					console.log(msg)
				}
				this.loading = false
			})
		}
	}
</script>
<style lang="scss">
	.weijuzheng {
		.item-list{
			display: flex;
			flex-flow: row wrap;
		}
		.item{
			width: 33.3%;
			text-align: center;
			margin-bottom: 2rem;
		}
		.item a{
			text-align: center;
			display: flex;
			flex-flow: column;
			align-items: center;
		}
		.logo{
			width: 3.1rem;
			height: 3.1rem;
			border-radius: 100%;
			border: 1px solid #F1F2F4;
			margin-bottom: .4rem;
		}
		.name{
			width: 6rem;
			font-size: .8rem;
			color: #333;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}

</style>